import { render } from "./MyLeads.vue?vue&type=template&id=32d58b16&scoped=true"
import script from "./MyLeads.vue?vue&type=script&lang=js"
export * from "./MyLeads.vue?vue&type=script&lang=js"

import "./MyLeads.vue?vue&type=style&index=0&id=32d58b16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d58b16"]])

export default __exports__